import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const spin = keyframes`  
    0% {
    transform: rotate(0);
    }

    100% {
    transform: rotate(360deg);
    }`;
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Spinner = styled.div`
  height: 70px;
  width: 70px;
  animation: ${spin} 0.7s infinite linear;
  border-color: transparent #76b900 #76b900;
  border-width: 5px;
  border-style: solid;
  border-radius: 50%;
`;
